import { API_BASE_URL } from "config";
import { StatusCodes } from "http-status-codes";

import { BaseService } from "./base-service";

export enum RECOMMENDATIONS_ENDPOINTS {
  USER = "/recommendations",
}

type ScoreKey = "score";

export enum REC_SOURCE {
  TEAM = "team",
  ORG = "org",
  AMZ = "amz",
  ROLE = "role",
}

export interface Recommendation {
  product_name: string;
  taxonomy_id: string;
  score: number;
  category: string;
  rec_source: string;
  in_use: boolean;
}

export interface GetRecommendationsResponse {
  recommendations: Recommendation[];
  areDefaultRecommendations: boolean;
}

export const transformTaxonomyIdForRecs = (id: string) => {
  return id;
};

export class RecommendationsService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  /**
   * Fetch the list of recommendations for the current user
   * @param options Optional filters: category, count, sortBy, includeInUse, and rec_source
   * @returns Array of recommendation entries
   */
  public async getRecommendations(options?: {
    category?: string;
    count?: number;
    sortBy?: ScoreKey;
    includeInUse?: boolean;
    rec_source?: string;
  }): Promise<GetRecommendationsResponse> {
    const queryParams = new URLSearchParams();

    if (options?.category) queryParams.set("category", options.category);
    if (options?.count !== undefined) queryParams.set("count", options.count.toString());
    if (options?.sortBy) queryParams.set("sortBy", options.sortBy);
    if (options?.includeInUse !== undefined) queryParams.set("includeInUse", options.includeInUse.toString());
    if (options?.rec_source) queryParams.set("rec_source", options.rec_source);

    const url = RECOMMENDATIONS_ENDPOINTS.USER + (queryParams.toString() ? `?${queryParams.toString()}` : "");
    const response = await this.fetch(url);

    if (response.status === StatusCodes.OK) {
      return await response.json();
    }

    throw new Error("Failed to fetch recommendations");
  }
}
